module.exports = __webpack_public_path__ + "static/media/gymate1.546d877b.png";